module.exports = __webpack_public_path__ + "static/media/icon_generic_image.b29a0fc0.svg";